export default "__VITE_ASSET__DzjDXVVb__"